/*eslint-disable*/
import api from '../'

class LevelApi {

  static update(id, request) {
    return api.axios.put('/olympiad/level/' + id, request)
        .then(response => response.data.level);
  }

  static show(id) {
    return api.axios.get('/olympiad/level/' + id)
      .then(response => response.data.level);
  }
}

export default LevelApi;
